import { takeEvery, put, call } from "redux-saga/effects"

// Calender Redux States
import {
  GET_ROLE,
  GET_ROLE_DETAILS,
  ADD_NEW_ROLE,
  UPDATE_ROLE,
  DELETE_ROLE,
  GET_PERMISSION,
} from "./actionTypes.js";

import {
  getRoleSuccess,
  getRoleFail,
  getRoleDetailsSuccess,
  getRoleDetailsFail,
  addRoleFail,
  addRoleSuccess,
  updateRoleSuccess,
  updateRoleFail,
  deleteRoleSuccess,
  deleteRoleFail,
  getPermissionSuccess,
  getPermissionFail,
} from "./action.js"

import {
  roleListingApi,
  permissionListingApi,
  roleDetailsApi,
  addNewRole,
  updateRole,
  delRole,
} from "./roleApi.js"

function* fetchRole({ payload: length, sort, page, sort_by }) {
  try {
    const response = yield call(roleListingApi, length, sort, page, sort_by)
    yield put(getRoleSuccess(response))
  } catch (error) {
    yield put(getRoleFail(error))
  }
}

function* fetchRoleDetails({ payload: id }) {
  try {
    const response = yield call(roleDetailsApi, id)
    yield put(getRoleDetailsSuccess(response))
  } catch (error) {
    yield put(getRoleDetailsFail(error))
  }
}

function* onAddNewRole({ payload: role }) {
  try {
    const response = yield call(addNewRole, role)
    yield put(addRoleSuccess(response))
  } catch (error) {
    yield put(addRoleFail(error))
  }
}

function* onUpdateRole({ payload: id, role }) {
  try {
    const response = yield call(updateRole, id, role)
    yield put(updateRoleSuccess(response))
  } catch (error) {
    yield put(updateRoleFail(error))
  }
}

function* onDelRole({ payload: id }) {
  try {
    const response = yield call(delRole, id)
    yield put(deleteRoleSuccess(response))
  } catch (error) {
    yield put(deleteRoleFail(error))
  }
}

function* fetchPermission({ payload: length, page, sort}) {
  try {
    const response = yield call(permissionListingApi, length, page, sort)
    yield put(getPermissionSuccess(response))
  } catch (error) {
    yield put(getPermissionFail(error))
  }
}

function* RoleSaga() {
  yield takeEvery(GET_ROLE, fetchRole)
  yield takeEvery(GET_PERMISSION, fetchPermission)
  yield takeEvery(GET_ROLE_DETAILS, fetchRoleDetails)
  yield takeEvery(ADD_NEW_ROLE, onAddNewRole)
  yield takeEvery(UPDATE_ROLE, onUpdateRole)
  yield takeEvery(DELETE_ROLE, onDelRole)
}

export default RoleSaga
